import React from 'react'
import styles from './DotLineLoader.module.scss'

function DotLineLoader() {
    return (
        <div className={styles.loader}>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
            <div className={styles.dot}></div>
        </div>
    )
}

export default DotLineLoader